"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterNodesByPlatformType = filterNodesByPlatformType;
const lodash_1 = __importDefault(require("lodash"));
const QuestionnaireVisitor_1 = __importDefault(require("../QuestionnaireVisitor"));
const structure_1 = require("../structure");
class FilterNodesByUserTypesVisitor extends QuestionnaireVisitor_1.default {
    userTypes;
    constructor(userTypes) {
        super();
        this.userTypes = userTypes;
    }
    visitQuestionnaire(questionnaire) {
        const clonedQuestionnaire = lodash_1.default.cloneDeep(questionnaire);
        const filteredQuestionnaire = this.filterNodesByPlatformType(clonedQuestionnaire);
        super.visitQuestionnaire(filteredQuestionnaire);
        return { questionnaire: filteredQuestionnaire, output: undefined };
    }
    visitSectionGroup(sectionGroup) {
        sectionGroup.sections = this.filterNodesByPlatformType(sectionGroup.sections);
        super.visitSectionGroup(sectionGroup);
    }
    visitSection(section) {
        section.subsections = this.filterNodesByPlatformType(section.subsections);
        super.visitSection(section);
    }
    visitSubsection(subsection) {
        subsection.fieldGroups = this.filterNodesByPlatformType(subsection.fieldGroups);
        super.visitSubsection(subsection);
    }
    visitFieldGroup(fieldGroup) {
        fieldGroup.fields = this.filterNodesByPlatformType(fieldGroup.fields);
        super.visitFieldGroup(fieldGroup);
    }
    visitField(field) {
        if ((0, structure_1.isOptionField)(field)) {
            if (field.options?.length > 0) {
                field.options = this.filterNodesByPlatformType(field.options);
            }
        }
    }
    filterNodesByPlatformType(nodes) {
        return nodes.filter((node) => this.nodeHasMatchingPlatformTypes(node));
    }
    nodeHasMatchingPlatformTypes(baseNode) {
        if (!baseNode.platformTypeFilter?.length) {
            // No platform type means this should always be included.
            return true;
        }
        const matches = lodash_1.default.intersection(baseNode.platformTypeFilter, this.userTypes);
        return !lodash_1.default.isEmpty(matches);
    }
}
function filterNodesByPlatformType(questionnaire, userTypes) {
    if (!userTypes.length) {
        return questionnaire;
    }
    const visitor = new FilterNodesByUserTypesVisitor(userTypes);
    const { questionnaire: filteredQuestionnaire } = visitor.visitQuestionnaire(questionnaire);
    return filteredQuestionnaire;
}
